/* gw-tabellen.js (L14, 20.10.2026): Tabellen auf Richtlinien- und Textseiten mobil lesbar und per Tastatur bedienbar.
   - /policies/*: Tabellen mit Kopfzeile und höchstens 5 Spalten bekommen data-label je Zelle und die Klasse gw-tab-stapel
     (CSS in assets/gw-l14.css stapelt sie unter 600 px). Andere Tabellen: Hülle .gw-tab-scroll (role=region, tabindex=0).
   - Cookie-Erklärung (Cookiebot, lädt asynchron): data-label je Zelle und Klasse gw-tab-karten (mobil Karten pro Cookie, CSS gw-l14.css).
     Läuft per MutationObserver und nach CookiebotOnLoad bzw. CookiebotOnConsentReady erneut, falls Cookiebot neu rendert.
   Geladen mit defer nur auf Richtlinien- und Inhaltsseiten (layout/theme.liquid). */
(function () {
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function kopf(t) {
    var r = t.tHead && t.tHead.rows[0];
    if (!r && t.rows[0] && t.rows[0].querySelectorAll('td').length === 0) r = t.rows[0];
    return r ? Array.prototype.map.call(r.cells, txt) : null;
  }
  function richtlinie(t) {
    if (t.dataset.gwTab) return; t.dataset.gwTab = '1';
    var k = kopf(t);
    if (k && k.length && k.length <= 5) {
      var start = t.tHead ? 0 : 1;
      Array.prototype.forEach.call(t.tBodies, function (b) {
        Array.prototype.forEach.call(b.rows, function (r, i) {
          if (!t.tHead && b === t.tBodies[0] && i < start) { r.classList.add('gw-tab-kopf'); return; }
          Array.prototype.forEach.call(r.cells, function (c, j) { if (k[j] && !c.hasAttribute('data-label')) c.setAttribute('data-label', k[j]); });
        });
      });
      t.classList.add('gw-tab-stapel');
      return;
    }
    var d = document.createElement('div');
    d.className = 'gw-tab-scroll'; d.tabIndex = 0; d.setAttribute('role', 'region');
    var vor = t.previousElementSibling;
    d.setAttribute('aria-label', (txt(t.caption) || (vor && /^H[2-4]$/.test(vor.tagName) ? txt(vor) : 'Tabelle')) + ', seitlich scrollbar');
    t.parentNode.insertBefore(d, t); d.appendChild(t);
  }
  function cookie(t) {
    /* Cookiebot-Tabelle: Labels aus der Kopfzeile an jede Zelle; Karten-Darstellung mobil per CSS (gw-tab-karten). Markup bleibt sonst unverändert. */
    var k = kopf(t); if (!k || !k.length) return;
    var kopfZeile = t.tHead ? null : t.rows[0];
    Array.prototype.forEach.call(t.rows, function (r) {
      if (r === kopfZeile || (r.parentNode && r.parentNode.tagName === 'THEAD')) { r.classList.add('gw-tab-kopf'); return; }
      Array.prototype.forEach.call(r.cells, function (c, j) { if (k[j]) c.setAttribute('data-label', k[j]); });
    });
    t.classList.add('gw-tab-karten');
  }
  function lauf() {
    document.querySelectorAll('.shopify-policy__body table:not(.CookieDeclarationTable)').forEach(richtlinie);
    document.querySelectorAll('.CookieDeclarationTable').forEach(function (t) { if (t.rows.length > 1 && t.dataset.gwKarten !== String(t.rows.length)) { t.dataset.gwKarten = String(t.rows.length); cookie(t); } });
  }
  lauf();
  window.addEventListener('CookiebotOnLoad', lauf);
  window.addEventListener('CookiebotOnConsentReady', lauf);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lauf);
  var ziel = document.querySelector('main') || document.body;
  if (ziel && 'MutationObserver' in window) {
    var mo = new MutationObserver(lauf);
    mo.observe(ziel, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
})();
